import { uuid } from "@/interfaces";
import { paymentSuggested, type PaymentCalculationResult } from "@/lib/suggested-pay";
import { VendorPropertyServicePricingRepository } from "@/repositories/vendor-property-service-pricing.repository";

export type { PaymentSource } from "@/lib/suggested-pay";

export const AssignmentPaymentService = {
  async calculatePayment(vendorId: uuid, propertyId: uuid, serviceId: uuid): Promise<PaymentCalculationResult> {
    return paymentSuggested(await VendorPropertyServicePricingRepository.listedAt(propertyId, vendorId, serviceId));
  },
};
